module.exports = __webpack_public_path__ + "img/server_icon.6bf072a2.svg";